import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/site";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

function Chapter({ item, index }) {
  const [hover, setHover] = useState(false);
  return (
    <motion.div
      variants={reveal}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-testid={`manifesto-chapter-${item.no}`}
      className="group grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-center border-t border-white/10 py-12 lg:py-16"
    >
      <div className="lg:col-span-1">
        <span className="font-mono-tech text-sm text-[#FF5A00]">{item.no}</span>
      </div>

      <div className="lg:col-span-5">
        <h3 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-tight text-[#F8FAFC] group-hover:text-[#FF5A00] transition-colors duration-500">
          {item.title}
        </h3>
      </div>

      <div className="lg:col-span-4">
        <p className="font-mono-tech text-sm leading-relaxed text-[#94A3B8]">{item.body}</p>
      </div>

      <div className="lg:col-span-2">
        <div className="relative h-28 w-full overflow-hidden">
          <motion.img
            src={item.img}
            alt={item.title}
            className="absolute inset-0 h-full w-full object-cover"
            initial={{ clipPath: "inset(100% 0 0 0)" }}
            animate={{
              clipPath: hover ? "inset(0% 0 0 0)" : "inset(100% 0 0 0)",
              scale: hover ? 1.08 : 1,
            }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          />
          <div className="absolute inset-0 border border-white/10" />
          {!hover && (
            <div className="absolute inset-0 grid place-items-center">
              <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#94A3B8]">
                Hover
              </span>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default function Manifesto() {
  const ref = useRef(null);
  return (
    <section
      id="capabilities"
      ref={ref}
      data-testid="manifesto-section"
      className="relative bg-[#050B14] py-24 lg:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="max-w-3xl mb-16 lg:mb-24"
        >
          <span className="font-mono-tech text-xs uppercase tracking-[0.35em] text-[#FF5A00]">
            Core Capabilities
          </span>
          <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F8FAFC] text-balance">
            Precision electrical engineering, built for the open sea.
          </h2>
          <p className="mt-6 font-mono-tech text-sm leading-relaxed text-[#94A3B8] max-w-xl">
            Four disciplines. One standard of reliability. We keep offshore power flowing
            where failure is not an option.
          </p>
        </motion.div>

        <div>
          {MANIFESTO.map((item, i) => (
            <Chapter key={item.no} item={item} index={i} />
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
}
